module.exports = __webpack_public_path__ + "3fb987b5a91337c0539f430b2181c421.svg";